import { CourseAnalytics, CourseFilterField } from '../types/courseAnalytics.types';
import { StanFilterConfig } from '@/components/core-components/StanFilters/types';

// Generate filter configurations
export const getCourseAnalyticsFilters = (
    analytics: CourseAnalytics | null,
    selectedModuleId?: string
): StanFilterConfig[] => {
    if (!analytics) return [];

    const moduleOptions = analytics.modules.map(module => ({
        label: module.label,
        value: module.id,
    }));

    // Filter lessons by selected module - show no options if no module is selected
    // Use type-safe comparison since filter values are always strings
    const lessonOptions = selectedModuleId
        ? analytics.lessons
              .filter(lesson => String(lesson.module_id) === String(selectedModuleId))
              .map(lesson => ({
                  label: lesson.label,
                  value: lesson.id,
              }))
        : [];

    return [
        {
            id: CourseFilterField.FAN_NAME,
            label: 'Name',
            type: 'text',
        },
        {
            id: CourseFilterField.FAN_EID,
            label: 'Email',
            type: 'text',
        },
        {
            id: CourseFilterField.FAN_SINCE,
            label: 'Start Date',
            type: 'date',
        },
        {
            id: CourseFilterField.MODULE_ID,
            label: 'Module',
            type: 'select',
            customDropdownOptions: moduleOptions,
            customDropdownReduce: 'value',
        },
        {
            id: CourseFilterField.LESSON_ID,
            label: 'Lesson',
            type: 'select',
            customDropdownOptions: lessonOptions,
            customDropdownReduce: 'value',
            disabled: !selectedModuleId,
        },
    ];
};
